import { Route } from '@angular/router';
import { ProjectTenantsComponent } from './tenants.component';
import { ProjectDataResolver } from 'app/modules/projects/projects.resolvers';
import {
  ProjectTenantsPropertiesResolver,
  ProjectTenantsPropertyResolver,
  ProjectTenantsPropertyUnitResolver,
} from 'app/modules/projects/details/tenants/tenants.resolvers';
import { ProjectTenantsListComponent } from 'app/modules/projects/details/tenants/list/list.component';
import { ProjectTenantsDetailsComponent } from 'app/modules/projects/details/tenants/details/details.component';
import { CanDeactivateTenantsDetails } from './tenants.guards';

export const tenantsRoutes: Route[] = [
  {
    path: '',
    component: ProjectTenantsComponent,
    resolve: {
      properties: ProjectTenantsPropertiesResolver,
      options: ProjectDataResolver,
    },
    children: [
      {
        path: ':property_id',
        component: ProjectTenantsListComponent,
        resolve: {
          property: ProjectTenantsPropertyResolver,
          options: ProjectDataResolver,
        },
        children: [
          {
            path: ':property_unit_id',
            component: ProjectTenantsDetailsComponent,
            resolve: {
              propertyUnit: ProjectTenantsPropertyUnitResolver,
            },
            canDeactivate: [CanDeactivateTenantsDetails],
          },
        ],
      },
    ],
  },
];
